export default function Component() {
  return (
    <header className="">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <img
                alt="YOKS Rent-a-Car"
                className="h-8 w-auto"
                src="image/home/logo1.png"
              />
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex flex-row items-baseline space-x-4">
                <a
                  className="text-white text-sm leading-5 hover:text-opacity-75 focus:outline-none focus:text-opacity-75 transition  flex  gap-2 duration-150 ease-in-out"
                  href="#"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1_514)">
                      <path
                        d="M19.1875 12.6375L17.4125 10.8625C17.0311 10.4984 16.5241 10.2952 15.9968 10.2952C15.4696 10.2952 14.9626 10.4984 14.5812 10.8625L13.9562 11.4875C13.5322 11.91 12.9579 12.1472 12.3593 12.1472C11.7607 12.1472 11.1865 11.91 10.7625 11.4875C10.2812 11.0062 9.97497 10.6812 9.66872 10.3625C9.36247 10.0437 9.04372 9.7 8.54372 9.20625C8.1216 8.78326 7.88454 8.21008 7.88454 7.6125C7.88454 7.01492 8.1216 6.44174 8.54372 6.01875L9.16872 5.39375C9.3551 5.20879 9.50298 4.98873 9.60381 4.74629C9.70465 4.50385 9.75645 4.24383 9.75622 3.98125C9.75395 3.45144 9.54285 2.94389 9.16872 2.56875L7.39372 0.78125C6.89229 0.281971 6.21383 0.0011493 5.50622 0C5.15766 0.000513631 4.81264 0.0697838 4.49089 0.203843C4.16915 0.337903 3.87702 0.534118 3.63122 0.78125L1.93747 2.4625C0.716925 3.68474 0.0313721 5.34144 0.0313721 7.06875C0.0313721 8.79606 0.716925 10.4528 1.93747 11.675C2.91247 12.65 4.02497 13.75 5.13122 14.9C6.23747 16.05 7.32497 17.125 8.29372 18.125C9.5157 19.3436 11.1711 20.028 12.8968 20.028C14.6226 20.028 16.278 19.3436 17.5 18.125L19.1875 16.4375C19.6837 15.9391 19.9643 15.2658 19.9687 14.5625C19.9749 14.2056 19.9088 13.851 19.7746 13.5202C19.6403 13.1895 19.4406 12.8892 19.1875 12.6375ZM18.2437 15.4687L18.0625 15.625L16.25 13.8062C16.1896 13.7375 16.1158 13.6818 16.0331 13.6427C15.9504 13.6036 15.8605 13.5819 15.7691 13.5789C15.6777 13.576 15.5866 13.5918 15.5015 13.6254C15.4164 13.659 15.3391 13.7098 15.2744 13.7745C15.2097 13.8392 15.159 13.9164 15.1254 14.0015C15.0918 14.0866 15.0759 14.1777 15.0789 14.2691C15.0819 14.3606 15.1036 14.4504 15.1427 14.5331C15.1818 14.6158 15.2375 14.6897 15.3062 14.75L17.15 16.5937L16.5875 17.1562C15.6151 18.1257 14.298 18.67 12.925 18.67C11.5519 18.67 10.2349 18.1257 9.26247 17.1562C8.29997 16.1937 7.20622 15.0812 6.13747 13.9687C5.06872 12.8562 3.91247 11.7125 2.93747 10.7375C1.96806 9.76511 1.42369 8.44806 1.42369 7.075C1.42369 5.70194 1.96806 4.38488 2.93747 3.4125L3.49997 2.85L5.28122 4.6875C5.40554 4.81596 5.5758 4.88978 5.75455 4.89271C5.93329 4.89564 6.10588 4.82745 6.23434 4.70312C6.36281 4.5788 6.43663 4.40854 6.43956 4.2298C6.44249 4.05105 6.37429 3.87846 6.24997 3.75L4.37497 1.875L4.55622 1.69375C4.67939 1.56859 4.82631 1.46929 4.98838 1.40168C5.15044 1.33406 5.32437 1.29949 5.49997 1.3C5.85429 1.30106 6.19371 1.44268 6.44372 1.69375L8.22497 3.5C8.3486 3.62475 8.41819 3.79312 8.41872 3.96875C8.4188 4.05578 8.40172 4.14197 8.36848 4.2224C8.33523 4.30283 8.28647 4.37592 8.22497 4.4375L7.59997 5.0625C6.92825 5.73616 6.55104 6.64867 6.55104 7.6C6.55104 8.55133 6.92825 9.46384 7.59997 10.1375C8.12497 10.625 8.41247 10.9312 8.74997 11.25C9.08747 11.5687 9.37497 11.9125 9.86872 12.4C10.5424 13.0717 11.4549 13.4489 12.4062 13.4489C13.3575 13.4489 14.2701 13.0717 14.9437 12.4L15.5687 11.775C15.6963 11.6546 15.8651 11.5875 16.0406 11.5875C16.216 11.5875 16.3849 11.6546 16.5125 11.775L18.2875 13.55C18.4123 13.6734 18.5115 13.8203 18.5791 13.9824C18.6467 14.1444 18.6814 14.3182 18.6812 14.4937C18.678 14.6765 18.6376 14.8567 18.5623 15.0232C18.4871 15.1898 18.3787 15.3393 18.2437 15.4625V15.4687Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1_514">
                        <rect width="20" height="20" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  + 233 540-614-545
                </a>
              </div>
            </div>
          </div>
          <div className="hidden md:block">
            <div className="ml-4 flex items-center md:ml-6">
              <span className="text-white text-sm leading-5 mr-4">
                Follow Us
              </span>
              <a
                className="text-white p-3 rounded-full hover:bg-[#ED8B00] hover:text-white focus:outline-none focus:bg-[#ED8B00] focus:text-white transition duration-150 ease-in-out"
                href="#"
              >
                <svg
                  width="9"
                  height="15"
                  viewBox="0 0 9 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.62891 8.52539H5.57812V14.6504H2.84375V8.52539H0.601562V6.00977H2.84375V4.06836C2.84375 1.88086 4.15625 0.650391 6.15234 0.650391C7.10938 0.650391 8.12109 0.841797 8.12109 0.841797V3.00195H7C5.90625 3.00195 5.57812 3.6582 5.57812 4.36914V6.00977H8.01172L7.62891 8.52539Z"
                    fill="white"
                  />
                </svg>
              </a>
              <a
                className="ml-3 text-white p-3 rounded-full hover:bg-[#ED8B00] hover:text-white focus:outline-none focus:bg-[#ED8B00] focus:text-white transition duration-150 ease-in-out"
                href="#"
              >
                <svg
                  width="14"
                  height="12"
                  viewBox="0 0 14 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.5508 2.80664C12.5508 2.94336 12.5508 3.05273 12.5508 3.18945C12.5508 6.99023 9.67969 11.3379 4.40234 11.3379C2.76172 11.3379 1.25781 10.873 0 10.0527C0.21875 10.0801 0.4375 10.1074 0.683594 10.1074C2.02344 10.1074 3.25391 9.64258 4.23828 8.87695C2.98047 8.84961 1.91406 8.0293 1.55859 6.88086C1.75 6.9082 1.91406 6.93555 2.10547 6.93555C2.35156 6.93555 2.625 6.88086 2.84375 6.82617C1.53125 6.55273 0.546875 5.4043 0.546875 4.00977V3.98242C0.929688 4.20117 1.39453 4.31055 1.85938 4.33789C1.06641 3.81836 0.574219 2.94336 0.574219 1.95898C0.574219 1.41211 0.710938 0.919922 0.957031 0.509766C2.37891 2.23242 4.51172 3.38086 6.89062 3.51758C6.83594 3.29883 6.80859 3.08008 6.80859 2.86133C6.80859 1.27539 8.09375 -0.00976562 9.67969 -0.00976562C10.5 -0.00976562 11.2383 0.318359 11.7852 0.892578C12.4141 0.755859 13.043 0.509766 13.5898 0.181641C13.3711 0.865234 12.9336 1.41211 12.332 1.76758C12.9062 1.71289 13.4805 1.54883 13.9727 1.33008C13.5898 1.9043 13.0977 2.39648 12.5508 2.80664Z"
                    fill="white"
                  />
                </svg>
              </a>
              <a
                className="ml-3 text-white p-3 rounded-full hover:bg-[#ED8B00] hover:text-white focus:outline-none focus:bg-[#ED8B00] focus:text-white transition duration-150 ease-in-out"
                href="#"
              >
                <svg
                  width="14"
                  height="13"
                  viewBox="0 0 14 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.125 3.50586C8.84766 3.50586 10.2695 4.92773 10.2695 6.65039C10.2695 8.40039 8.84766 9.79492 7.125 9.79492C5.375 9.79492 3.98047 8.40039 3.98047 6.65039C3.98047 4.92773 5.375 3.50586 7.125 3.50586ZM7.125 8.70117C8.24609 8.70117 9.14844 7.79883 9.14844 6.65039C9.14844 5.5293 8.24609 4.62695 7.125 4.62695C5.97656 4.62695 5.07422 5.5293 5.07422 6.65039C5.07422 7.79883 6.00391 8.70117 7.125 8.70117ZM11.1172 3.39648C11.1172 3.80664 10.7891 4.13477 10.3789 4.13477C9.96875 4.13477 9.64062 3.80664 9.64062 3.39648C9.64062 2.98633 9.96875 2.6582 10.3789 2.6582C10.7891 2.6582 11.1172 2.98633 11.1172 3.39648ZM13.1953 4.13477C13.25 5.14648 13.25 8.18164 13.1953 9.19336C13.1406 10.1777 12.9219 11.0254 12.2109 11.7637C11.5 12.4746 10.625 12.6934 9.64062 12.748C8.62891 12.8027 5.59375 12.8027 4.58203 12.748C3.59766 12.6934 2.75 12.4746 2.01172 11.7637C1.30078 11.0254 1.08203 10.1777 1.02734 9.19336C0.972656 8.18164 0.972656 5.14648 1.02734 4.13477C1.08203 3.15039 1.30078 2.27539 2.01172 1.56445C2.75 0.853516 3.59766 0.634766 4.58203 0.580078C5.59375 0.525391 8.62891 0.525391 9.64062 0.580078C10.625 0.634766 11.5 0.853516 12.2109 1.56445C12.9219 2.27539 13.1406 3.15039 13.1953 4.13477ZM11.8828 10.2598C12.2109 9.4668 12.1289 7.55273 12.1289 6.65039C12.1289 5.77539 12.2109 3.86133 11.8828 3.04102C11.6641 2.52148 11.2539 2.08398 10.7344 1.89258C9.91406 1.56445 8 1.64648 7.125 1.64648C6.22266 1.64648 4.30859 1.56445 3.51562 1.89258C2.96875 2.11133 2.55859 2.52148 2.33984 3.04102C2.01172 3.86133 2.09375 5.77539 2.09375 6.65039C2.09375 7.55273 2.01172 9.4668 2.33984 10.2598C2.55859 10.8066 2.96875 11.2168 3.51562 11.4355C4.30859 11.7637 6.22266 11.6816 7.125 11.6816C8 11.6816 9.91406 11.7637 10.7344 11.4355C11.2539 11.2168 11.6914 10.8066 11.8828 10.2598Z"
                    fill="white"
                  />
                </svg>
              </a>
              <a
                className="ml-3 text-white p-3 rounded-full hover:bg-[#ED8B00] hover:text-white focus:outline-none focus:bg-[#ED8B00] focus:text-white transition duration-150 ease-in-out"
                href="#"
              >
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.73438 12.9004H0.191406V4.72461H2.73438V12.9004ZM1.44922 3.63086C0.65625 3.63086 0 2.94727 0 2.12695C0 1.33398 0.65625 0.677734 1.44922 0.677734C2.26953 0.677734 2.92578 1.33398 2.92578 2.12695C2.92578 2.94727 2.26953 3.63086 1.44922 3.63086ZM12.2227 12.9004H9.70703V8.93555C9.70703 7.97852 9.67969 6.77539 8.36719 6.77539C7.05469 6.77539 6.86328 7.78711 6.86328 8.85352V12.9004H4.32031V4.72461H6.75391V5.8457H6.78125C7.13672 5.2168 7.95703 4.5332 9.1875 4.5332C11.7578 4.5332 12.25 6.22852 12.25 8.41602V12.9004H12.2227Z"
                    fill="white"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

function FacebookIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
    </svg>
  );
}

function PhoneIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
  );
}
